export const ContactsData = [
    [
        {
            name: 'first_name',
            label: 'Имя',
            placeholder: 'Иван',
            type: 'text',
            maskConfig: { mask: /^[A-Za-zА-Яа-яЁё\s]{0,50}$/ },
            required: true,
        },
        {
            name: 'surname',
            label: 'Фамилия',
            placeholder: 'Иванов',
            type: 'text',
            maskConfig: { mask: /^[A-Za-zА-Яа-яЁё\s]{0,50}$/ },
            required: true,
        },
        {
            name: 'patronymic',
            label: 'Отчество',
            placeholder: 'Иванович',
            type: 'text',
            maskConfig: { mask: /^[A-Za-zА-Яа-яЁё\s]{0,50}$/ },
            // required: true,
        },
        {
            name: 'phone',
            label: 'Телефон',
            placeholder: 'Введите',
            type: 'text',
            maskConfig: { mask: '+{7}-000-000-00-00' },
            // required: true,
        },
        {
            name: 'email',
            label: 'Почта',
            placeholder: 'Введите',
            type: 'email',
            required: true,
            maskConfig: {
                mask: /^[^а-яА-Я]{0,50}$/,
            },
        },
    ],
]
